
<mat-form-field appearance="fill">

  <mat-label ssFormLabel></mat-label>
  <ss-phone-control></ss-phone-control>

  <mat-error ssFormValidationMessage></mat-error>
  <mat-icon matSuffix>phone</mat-icon>

</mat-form-field>

